var React = require('react');
var moment = require('moment');
var labels = require('MemberJoinLabels');
var memberTypeChecker = require('../../../../../Scripts/React/MemberTypeChecker.jsx').step4;
var { $input, $datePicker, $radioButtons } = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationComponents.jsx');
var validationFunctions = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationFunctions.jsx');

class BoardCertifications extends React.Component {
    constructor(props) {
        super(props);

        this.getBoardCertificationNumberMarkup = this.getBoardCertificationNumberMarkup.bind(this);
        this.handleBoardCertificationChange = this.handleBoardCertificationChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.hasBoardCertification = this.hasBoardCertification.bind(this);
    }

    handleInputChange(event) {
        this.props.updateStepState(event.target.name, event.target.value);
    }

    hasBoardCertification() {
        return this.props.stepState.boardCertification && this.props.stepState.boardCertification !== 'Not Certified';
    }

    handleBoardCertificationChange(event) {
        this.props.updateStepState(event.target.name, event.target.value);

        if (!this.hasBoardCertification()) {
            this.props.updateStepState('boardCertificationNumber', '');
            this.props.updateStepState('boardCertificationDate', '');
        }
    }

    getBoardCertificationNumberMarkup() {
        if (this.hasBoardCertification()) {
            return <div className={"field-wrap"}>
                <span>{this.props.stepState.boardCertification} {this.props.stepState.boardCertification === "ABA" ? labels.step4.abaBoardId : labels.step4.aobaBoardId}</span>
                <$input name="boardCertificationNumber" value={this.props.stepState.boardCertificationNumber} boardId={this.props.stepState.boardCertification} onChange={this.handleInputChange} validations={[validationFunctions.required, validationFunctions.boardCertificationNumber]} />
            </div>;
        }
    }

    render() {
        if (memberTypeChecker.hideBoardCertifications(this.props.appState.appType)) {
            return null;
        }

        const certNumber = this.getBoardCertificationNumberMarkup();

        return <div className={"board-certifications-container"}>

            <div className={"row"}>
                <div className={"panel"}>
                    <div className={"col-md-12"}>
                        <h3>{labels.step4.boardCertifications}</h3>
                    </div>
                    <div className={"edit"}>
                        <div className={"col-md-6"}>
                            <div className={"field-group-wrap"}>
                                <label>{labels.step4.abaOrAoba}</label>
                                <$radioButtons name="boardCertification" value={this.props.stepState.boardCertification} onChange={this.handleBoardCertificationChange} validations={[validationFunctions.required]} />
                            </div>
                            {certNumber}                          
                        </div>
                    </div>
                </div>
            </div>

        </div>;
    }
}

module.exports = BoardCertifications;